exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* explorer */\n/* actionbar */\n:host {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding-top: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 1rem;\n  display: block;\n  background-color: #ffffff; }\n  :host .container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow-y: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/file-upload/file-upload.component.scss
// module id = ../../../../../src/app/modules/ui-base/components/file-upload/file-upload.component.scss
// module chunks = main